import { Box, Card, CircularProgress, Grid } from "@mui/material";
import { memo, useCallback } from "react";
import SchedulingBeneficiary from "../../VirtualEmergencyCare/SchedulingBeneficiary";
import { ISelectBeneficiaryCardProps } from "./models";

export const SelectBeneficiaryCard = memo(
  ({ padding, beneficiary, loading, onClick }: ISelectBeneficiaryCardProps) => {
    const onRegisterPerson = useCallback(async () => {
      onClick(beneficiary);
    }, [onClick, beneficiary]);

    return (
      <Card
        sx={(theme) => ({
          padding: padding ? padding : 2,
          width: "100%",
          maxWidth: 450,
          maxHeight: 200,
          border: `2px solid transparent`,
          cursor: "pointer",
          position: "relative",
          backgroundColor:
            theme.palette.mode === "light"
              ? theme.palette.grey[100]
              : "#121212",
        })}
        onClick={loading ? undefined : onRegisterPerson}
        elevation={0}
      >
        {loading && (
          <Box
            sx={{
              bottom: 2,
              height: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "absolute",
            }}
          >
            <CircularProgress />
          </Box>
        )}
        <Grid
          container
          sx={{ flexDirection: "row", opacity: !loading ? 1 : 0.25 }}
        >
          <SchedulingBeneficiary beneficiary={beneficiary} />
        </Grid>
      </Card>
    );
  }
);
